<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="section" v-on:click="goTo('/stats')">Estadísticas</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Mensuales</a>
  </div>
  <h1 class="ui header"><i class="icon chart bar"></i><div class="content">Estadísticas: {{year}} {{hilabetea}} </div></h1>
  <div class="rightButton">
  <a class="section" v-on:click="changeMonth(year,month-1)"><i class="big arrow alternate circle down icon"></i></a>
    <a class="section" v-on:click="changeMonth(year,parseInt(month)+1)"><i class="big arrow alternate circle up icon"></i></a>
  </div>
  <div v-if="!data" class="ui active centered inline loader"></div>
  <div v-if="data" class="ui stackable column divided grid container">
    <div class="row">
      <div class="column">
        <chartjs-line :fill="true" :datalabel="mylabel" :labels="mylabels" :data="mydata" :bordercolor="'#00f9a9'" :backgroundcolor="'rgba(0,249,169,0.1)'"></chartjs-line>
      </div>
    </div>
    <div class="row" style="text-align:center">
      <div class="column">
        <div class="ui huge horizontal statistic">
          <div class="value">
            {{totala}}
          </div>
          <div class="label">PAQUETES RECOGIDOS EN <H1>{{year}} {{hilabetea}}</H1></div>
        </div>
      </div>
    </div>
    <div v-if="(this.role==='master'||this.role==='admin')"  class="row">
      <div class="column">
        <h4 class="ui horizontal divider header">
          <i class="bar chart icon"></i>
          Recogidas por clientes
        </h4>
        <div class="ui seven cards" >
          <a class="card" v-for="data in clientData" :key="data.key" v-on:click="goTo('/stats/'+data.key+'/'+year+'/'+month)">
            <div class="image">
              <!-- <img v-if="data.url" class="ui image" :src="data.url" v-bind:alt="data.key">
              <img v-if="!data.url" class="ui image" src="../../assets/name.png"> -->

              <img class="ui image" :src="data.url" v-bind:alt="data.key">
            </div>
            <div class="content">
              <b class="rec">{{data.value}}</b>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'statMonth',
  props: ['year','month'],
  data() {
    return {
      role: null,
      image_url: null,
      data:null,
      mylabels:null,
      mydata:null,
      hilabetea:null,
      totala:null,
      mylabel:'Paquetes recogidos',
      clientData: null,
      images: []
    }
  },
  created() {
    this.role = JSON.parse(localStorage.admin).role
    this.getImages()
  },
  methods: {
    async getImages() {
      await hapiickApi().get('/v1/images/stats?admin_id='+JSON.parse(localStorage.admin).id)
      .then(request => {
        this.images = JSON.parse(JSON.stringify(request.data.data))
      })
      .catch((error) => {
        console.log('error getting images')
        console.log(error)
      })
      this.getStats(this.year,this.month)
    },
    getStats(year,month) {
      this.data = null
      let hoy = new Date();
      let current_year = hoy.getFullYear();
      let current_month = hoy.getMonth()+1;
      this.last_day = 31;
      if (year+'/'+month == current_year+'/'+current_month) {
        this.last_day = hoy.getDate();
      }

      hapiickApi().post('/v3/stats/months', {
        admin_id: JSON.parse(localStorage.admin).id,
        year: year,
        month: month
      })
      .then(request => this.updateStatistics(request))
      .catch(() => console.log('error getting stats'))
    },
    updateStatistics(req) {
      this.data = JSON.parse(JSON.stringify(req.data.data))

      let client = []
      for (var key in this.data.client) {
        let clientInfo = {}
        clientInfo.value = this.data.client[key];
        clientInfo.key = key;

        clientInfo.url = null

        if (this.images !== null) {
          let url = this.images.find((e) => {
            return (e.key === key)
          })
          if (url !== undefined) {
            clientInfo.url = url.url
          }
        }

        client.push(clientInfo)
      }
      this.clientData = client

      this.hilabetea = this.$months[this.month-1] //this.$months >> main.js
      let datuak = {...this.data.monthPicks};

      let egunak = []
      let zerrenda = []

      for (let i = 1; i <= this.last_day; i++) {
        egunak.push(this.year+'/'+this.month+'/'+i)

        if (i < 10) {
          i = '0' + i;
        } else {
          i = i;
        }

        let fecha = this.year+'-'+this.month.padStart(2, 0)+'-'+i;
        if (datuak.hasOwnProperty(fecha)) {
          zerrenda.push(datuak[fecha]);
        } else {
          zerrenda.push(0);
        }
      }

      this.mylabels = egunak;
      this.mydata = zerrenda;
      this.totala=zerrenda.reduce((a, b) => a + b);
    },
    goTo(where) {
      this.$router.push(where)
    },
    changeMonth(year,month){
      if(month <= 0){
        //year = year - 1
        year --;
        month = 12;
      }else if(month >= 13){
        //year = year + 1 // 2020 + 1 >> 20201 (Con el + lo concatena no lo suma)
        year ++;
        month = 1;
      }
      this.goTo('/stats/'+year+'/'+month)
      this.getStats(year,month)
    }
  }
}
</script>
<style scoped>
.rec{
  color:black;
}
</style>



// WEBPACK FOOTER //
// src/components/Stats/statsMonth.vue